import react from "react";
import './Work.css';
import { useState, useEffect } from "react";

    
function Work() {
    
    const [blockone, setblockone] = useState(true);
    const [blocktwo, setblocktwo] = useState(true);
    const [blockfive, setblockfive] = useState(true);
    
    const handleToggleBlock = (blockSetter) => {
    blockSetter(prevState => !prevState);
    };
    
    useEffect(() => {
        const circles = document.querySelectorAll('.circle');
        let index = 0;

        const interval = setInterval(() => {
            if (index >= circles.length) {
                index = 0;
            }
            const currentCircle = circles[index];
            currentCircle.style.backgroundColor = "rgb(97, 183, 225)";
            circles.forEach((circle) => {
                if (circle !== currentCircle) {
                    circle.style.backgroundColor = "white";
                }
            });
            index++;
        }, 2000);

return () => clearInterval(interval);
}, []);


    return (
        <div className="contacts">
            <div className="work">
                <h3>Как мы работаем?</h3>
                <div className="steps" onClick={() => handleToggleBlock(setblockone)} >
                    <div className="circle">1</div>
                    <p>Подача заявки на сертификацию в орган по сертификации.</p>
                    <div className="more">
                    <div className="imag"  style={{ backgroundImage: blockone ? 'url("../plus.png")' : 'url("../minus.png")',}}></div>
                    </div>
                </div>
                <div className="description"  style={{ display: blockone ? 'none' : 'block',}}>
                    <p>Форму заявки можно найти в разделе “Документы”</p>
                    <p>
                    Одновременно с заявкой предоставляются:<br></br>
                    • описание услуги и порядка ее представления, разрешение государственной комиссии
                    по радиочастотам при Мининформсвязи России на использование полос частот для
                    эксплуатации космических радиоэлектронных средств (при предоставлении услуг в
                    области систем космической связи);<br></br>
                    • ТТЗ, ТУ на космическую технику, аппаратуру, оборудование, используемые при
                    предоставлении космических услуг, требования к услуге, изложенные в контракте с
                    потребителем;<br></br>
                    • сертификат соответствия на космическую технику, используемую при
                    предоставлении космической услуги;<br></br>
                    • документы, подтверждающие гарантии защиты интересов государства, персонала,
                    имущества от потерь и повреждений в результате осуществления услуг по выведению
                    полезной нагрузки;<br></br>
                    • документы, подтверждающие обеспечение безопасности при предоставлении услуг;<br></br>
                    • таблица соответствия предлагаемой услуги заданным требованиям (можно найти в разделе "документы");<br></br>
                    • другая документация, необходимая для всесторонней и объективной оценки
                    соответствия характеристик космической услуги (по требованию органа по
                    сертификации)
                    </p>
                    </div>
                <div className="steps" onClick={() => handleToggleBlock(setblocktwo)}>
                        <div className="circle">2</div>
                            <p>Рассмотрение заявки OC и принятие решения о возможности и условиях проведения сертификации.</p>
                            <div className="more"><div className="imag"  style={{ backgroundImage: blocktwo ? 'url("../plus.png")' : 'url("../minus.png")',}}></div>
                        </div>
                    </div>
                    <div className="description"  style={{ display: blocktwo ? 'none' : 'block',}}>
                        <p>
                        Орган по сертификации в течение месяца рассматривает представленные материалы,
                        и принимает решение о возможности или невозможности
                        сертификации предлагаемой космической услуги, о чем сообщается заявителю.
                        При положительном решении орган по сертификации создает экспертную
                        комиссию для проведения оценки соответствия космической услуги предъявленным
                        требованиям.</p>
                    </div>
                <div className="steps">
                <div className="circle">3</div>
                    <p>Проведение процедур сертификации в соответствии с правилами, принятыми в системе.</p>
                </div>
                <div className="steps">
                <div className="circle">4</div>
                    <p>Анализ полученных результатов и принятие решение о возможности выдачи сертификата соответствия.</p>
                </div>
                <div className="steps" onClick={() => handleToggleBlock(setblockfive)}  >
                <div className="circle">5</div>
                    <p>Регистрация в реестре ФСС КТ и выдачу сертификата соответствия.</p>
                <div className="more"> 
                <div className="imag"  style={{ backgroundImage: blockfive ? 'url("../plus.png")' : 'url("../minus.png")',}}></div></div>
                </div>
                <div className="description"  style={{ display: blockfive? 'none' : 'block',}}>
                <p>
                    Сертификат соответствия на космическую услугу оформляет орган по сертификации
                при положительном заключении экспертной комиссии. После регистрации в реестре ФСС
                КТ сертификат выдается заявителю. Сертификат вступает
                в силу с даты его регистрации в реестре ФСС КТ.<br></br>
                Срок действия сертификата – до пяти лет.<br></br>
                Держателем сертификата является заявитель (поставщик или потребитель
                космической услуги).<br></br>
                В течение срока действия сертификата орган по сертификации осуществляет надзор
                за соответствием сертифицированной услуги предъявленным требованиям.</p>
                </div>
                <div className="steps">
                <div className="circle">6</div>
                    <p>Осуществление инспекционного контроля за серти­фицированной продукцией (если это предусмотрено схе­мой сертификации)</p>
                </div>
            </div>
            
        </div>
    )
}

export default Work;